<script>

	import { fly } from 'svelte/transition';

	export let tooltip;

	let out;
	$: out = (tooltip.out) ? tooltip.out : { duration: 100, y: 3 };

</script>

<style>
	.tooltip {
		position: absolute;
		padding: 12px;
		box-sizing: border-box;
		z-index: 9999;
		background: var(--textColor);
		color: var(--bgColor);
		border-radius: 3px;
		min-width: 160px;
		max-width: 220px;
		height: auto;
		transform: translate(-50%, -100%);
		left: 0.5rem;
		top: -10px;
		font-size: 0.9em;
	}
	.tooltip:before {
		content: '';
		position: absolute;
		bottom: -5px;
		left: calc(50% - 5px);
		width: 10px;
		height: 10px;
		box-sizing: border-box;
		background: var(--textColor);
		transform: rotate(45deg);
	}
</style>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
	class="tooltip"
	in:fly|local={{ duration: 300, y: 5 }}
	out:fly|local={out}
	on:click|stopPropagation
>
	<slot></slot>
</div>
